module.exports = __webpack_public_path__ + "dbeafd338a9b8d64a51ef629885f2068.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/JM.svg
// module id = 1U12
// module chunks = 0